module.exports = __webpack_public_path__ + "img/passaporte-qrcode-govbr.ae077efc.png";